<template>
  <div class="wrapper">
    <Header class="black"></Header>

    <div class="main">
      <div class="slogan">
        <div class="h1">打造视频梦工厂</div>
        <div class="h2">懂视频·更懂你</div>
      </div>

      <div class="container">
        <div class="title">
          <span><a href="about.html">关于我们</a></span>
          <span><a href="flow.html">服务流程</a></span>
          <span class="active">常见问题</span>
        </div>

        <div class="box">
          <div class="section">
            <div class="h1">客户篇</div>
            <div class="content clearfix">
              <dl>
                <dt>如何发布项目？</dt>
                <dd>在首页上方导航栏点击“我要拍片”或者在右侧悬浮栏点击“发布意向单”，填写项目需求并提交。我们的项目经理会在1、2天内通过您留下的联系方式联系您，和您沟通并对项目进行评估，评估过后会为您的项目匹配合适的制作人/团队。</dd>
              </dl>

              <dl>
                <dt>我可以取消项目吗？</dt>
                <dd>沟通阶段的项目可以取消项目，签订合同之后的项目以合同条款为准。</dd>
              </dl>

              <dl>
                <dt>我可以要求退款吗？</dt>
                <dd>项目立项后会签订合同，退款规则以合同条款为准。</dd>
              </dl>

              <dl>
                <dt>我能自己选择制作人/团队吗？</dt>
                <dd>我们会为您匹配合适的制作人/团队，如果您希望自己指定制作人/制作团队，我们会在给出合理建议的基础上尊重您的选择，为您联系并沟通档期，如因制作人/团队个人问题不能接项目，趣编网不承担责任。</dd>
              </dl>

              <dl>
                <dt>如何查看项目？</dt>
                <dd>登陆后在首页上方导航栏点击头像—我的项目，可以查看您正在进行的项目和历史项目，点击进入项目详情可以查看项目状态、项目信息以及相关文件。</dd>
              </dl>

              <dl>
                <dt>制作人可能在世界各地，如何保证拍摄质量？</dt>
                <dd>我们设有监制团队，全程监管项目拍摄制作，充分保障视频质量。</dd>
              </dl>
            </div>
          </div>

          <div class="section">
            <div class="h1">制作人篇</div>
            <div class="content clearfix">
              <dl>
                <dt>什么是制作人？</dt>
                <dd>“制作人”是平台用户经过认证后的身份，是审核确认过具有一定能力的影视从业人员。</dd>
              </dl>

              <dl>
                <dt>如何成为制作人？</dt>
                <dd>在首页点击“成为制作人”或登陆后在制作人主页点击“制作人认证”，填写资料并提交审核，我们会尽快与您联系审核您的制作人资质，通过审核后即可成为认证制作人。</dd>
              </dl>

              <dl>
                <dt>认证制作人后我能做什么？</dt>
                <dd>经过认证后，趣编网会根据您的擅长项目类型、风格、角色定位、地点等为您匹配合适的项目。<br/>您还可以管理您的个人主页并建立作品集，向别人展现您的专业能力、项目经验等优势，优秀的个人主页可能会吸引用户直接邀请您参与项目制作。</dd>
              </dl>

              <dl>
                <dt>接到项目后的操作流程是什么样的？</dt>
                <dd>制片人接到项目并确认→制片人组建团队→制片人制作并提交价格清单（包括人员场地器材等项目相关所有价格明细）→拍摄→验收→结算</dd>
              </dl>

              <dl>
                <dt>我是制片人，接到项目后如何组建制作团队？</dt>
                <dd>制片人接到项目并确认后，可在“我的项目”项目详情中选择合适的团队成员组建团队，提交团队后，我们的项目经理会联系各团队成员并建立群组进行沟通，项目经理会帮助进行团队的组建和协调各种问题，沟通后确定最终团队成员名单。</dd>
              </dl>

              <dl>
                <dt>我想要邀请趣编网上的一名制作人参与项目制作，该怎么做？</dt>
                <dd>如果您是制片人且接到趣编网为您匹配的项目，您可以直接在“我的项目”项目详情中使用组建团队功能选择该制作人；<br/>如果您是自己的项目，您可以拨打趣编网客服电话告知您的需求，我们会帮您联系该制作人。</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
  import '@/assets/js/common'
  import Header from  '@/components/Header'
  import Footer from  '@/components/Footer'
  import player from "@/components/Player";

  export default {
    components:{
      Header,
      Footer,
      player
    },
    data(){
      return{
        video:{
          src: 'https://qvbian-app.oss-cn-hangzhou.aliyuncs.com/index/cases/n1523843461419b.mp4',
          poster: 'https://static.qvbian.com/avator/201801/k1516004391410F.jpg'
        }
      }
    },
    mounted(){
    },
    methods:{

    }
  }
</script>

<style scoped>
  .main{ padding: 0 0 219px;}

  .slogan{ margin-bottom: 30px; padding-top: 33px; height: 200px; text-align: center; color: #ffffff; background: url("../../assets/images/about_slogan.png") no-repeat scroll center;}
  .slogan .h1{ font-size: 54px;}
  .slogan .h2{ margin-top: 13px; font-size: 24px; letter-spacing: 4px;}

  .title{text-align: center; background: #FFFFFF; border-radius: 2px;}
  .title span{ position: relative; display: inline-block; margin-right: 108px; width: 100px; line-height: 60px; font-size: 16px; color: #424753; opacity: 0.6;}
  .title span.active{ opacity: 1; font-weight: bold;}
  .title span.active:before{ content: ""; position: absolute; display: inline-block; bottom: 0; left: 35px; width: 30px; height: 0; border-bottom: #424753 solid 3px;}
  .title span:last-child{ margin-right: 0;}
  .title span a{ color: #424753;}

  .section{ margin-top: 30px; padding: 36px 75px 0; background: #ffffff;}
  .section .h1{ margin-bottom: 30px; font-size: 18px; text-align: center; font-weight: 600;}
  .section dl{ float: left; margin-left: 90px; width: 290px;}
  .section dl:nth-child(3n+1){ margin-left: 0;}
  .section dl dt{ padding: 10px 0; position: relative; font-size: 14px; color: #424753; font-weight: bold;}
  .section dl dt:after{ content: ""; position: absolute; left: 0; bottom: 0; width: 20px; height: 0px; border-bottom: 1px solid #979797;}
  .section dl dd{ margin-top: 15px; height: 144px; font-size: 12px; color: #424753; line-height: 20px;}
</style>



// WEBPACK FOOTER //
// App.vue?10e0a3d8